import { createClient } from "@supabase/supabase-js";
import { SUPABASE_URL, SUPABASE_KEY } from "./config";

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

//import { createClient } from '@supabase/supabase-js'

// Hem Vite hem de CRA ihtimaline karşı güvenli okuma:
//const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL || process.env?.REACT_APP_SUPABASE_URL;
//const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_KEY || process.env?.REACT_APP_SUPABASE_KEY;

//if (!supabaseUrl || !supabaseAnonKey) {
//  console.warn("Supabase URL veya Key bulunamadı! Lütfen Environment Variables ayarlarını kontrol edin.");
//}

//export const supabase = createClient(supabaseUrl, supabaseAnonKey)

